<template>
  <div>
    <InputGroup :show-errors="true"
                validation-id="price"
                v-model="object.price"
                :readonly="lastPrice !== null"
                :label="$t('price')"
                :required="true">
      <div v-if="lastPrice !== null" class="small text-muted">{{ $t('price_will_be_used_automatically_from_addition') }}:
        <span class="font-weight-bold ml-1">{{ formatCurrency(lastPrice)}}</span>
      </div>
    </InputGroup>
  </div>
</template>

<script setup>
import InputGroup from "@/components/form/InputGroup.vue"
import {onMounted, ref} from "vue"
import {WarehouseService} from "@/services/api/warehouse.api.service"
import {formatCurrency} from "@/extensions/filters/filters"

const props = defineProps({
  object: {
    type: Object
  },
  field: {},
  required: {},
})

const lastPrice = ref(null)

onMounted(() => {
  if(props.object.material_id) {
    WarehouseService.getMaterialLastPrice(props.object.material_id).then(response => {
      lastPrice.value = response?.data?.lastPrice || null
    }).catch(error => {
      console.log(error)
      lastPrice.value = null
    })
  }
})


</script>
